/**
 * External dependencies
 */

/**
 * React dependencies
 */

import React, { useEffect, useState } from 'react';

/**
 * DWT dependencies
 */

/**
 * DWT hooks
 */

import useMediaQuery from '../../../hooks/useMediaQuery';
import useFilterForCheckbox from '../hooks/useFilterForCheckbox';
import { FilterHelpers } from '../FilterConfig';

/**
 * DWT components
 */

import Checkbox from '../../UI/Checkbox';
import FilterTitle from '../FilterTitle';
import FilterResetButton from '../FilterResetButton';

/**
 * FilterPostItem
 *
 * Renders a list item for each post type (bookcategory, imprint, agerange, brand, booktheme, series, collection)
 * Handles all filter post types with configuration-driven approach
 *
 * @param {Object} props
 * @param {string} props.context
 * @param {Object} props.setStart
 * @param {string} props.filterPostType
 * @param {string} props.dataCode
 * @param {string} props.title
 * @param {Array} props.data
 * @param {Function} props.scrollToTop
 * @param {boolean} props.contributorsListing
 */
const FilterPostItem = ({ context, setStart, filterPostType, dataCode, title, data, scrollToTop, contributorsListing }) => {
  const isDesktop = useMediaQuery( '( min-width: 1024px )' );
  
  const code = FilterHelpers.getContextCode( filterPostType, context );
  const [ isActive, setIsActive ] = useState( false );
  const trimCode = code?.replace( /\s/g, '' )?.replace( /^,|,$/g, '' ); // Removes ALL whitespace characters (spaces, tabs, newlines) & Removes leading or trailing commas
  const sortCode = ( str ) => {
    // Splits a comma-separated string into an array,
    // sorts the array alphabetically,
    // and returns the sorted array.
    return str?.split( ',' ).sort();
  };
  const {
    checked,
    setChecked,
    handleFilter,
    initialObj
  } = useFilterForCheckbox( setStart, dataCode, scrollToTop, trimCode );

  useEffect( () => {
    if ( !isActive && isDesktop && contributorsListing && dataCode === 'data-category-code' ) {
      setIsActive( true );
    }
  }, [ isDesktop ] );

  const getCheckedState = ( item ) => 
    FilterHelpers.getCheckedState( filterPostType, item, checked, sortCode );

  const getCheckboxValue = ( item ) => 
    FilterHelpers.getACFValue( filterPostType, item, sortCode );

  const filterTitleClickHandler = () => {
    setIsActive( cur => !cur );
  };

  return (
    data.length > 0 && (
      <li className={ `filters__list-item text-[#121212] ${isActive ? 'is-active' : 'is-inactive'} ` }>
        <FilterTitle title={ title } onClick={ filterTitleClickHandler } />
        <ul className={ `filters__submenu text-14 flex flex-col gap-15 list-none mb-20 pl-0 ml-0 ${data?.length > 7 ? 'lg:h-[267px] lg:overflow-y-scroll' : 'lg:h-auto'}` }>
          { data.map( ( item ) => (
            item?.status === 'publish' && (
              <li
                className="submenu__list-item mb-0"
                data-slug={ item.slug }
                data-post-type={ item.type }
                key={ self.crypto.randomUUID() }
              >
                <Checkbox
                  obj={ item }
                  id={ item.slug }
                  name={ item.slug }
                  checked={ getCheckedState( item ) }
                  value={ getCheckboxValue( item ) }
                  onChange={ handleFilter }
                />
              </li>
            )
          ) ) }
        </ul>
        <FilterResetButton setStart={ setStart } checked={ checked } setChecked={ setChecked } dataFilter={ dataCode } scrollToTop={ scrollToTop } initialObj={ initialObj } />
      </li>
    )
  );
};

export default FilterPostItem;
